import { useCallback, useState } from 'react';

import { useAuth } from '@sbv-clients/shared-feature-auth';
import {
  Box,
  Chip,
  IconButton,
  Icon,
  Tooltip,
  Typography,
} from '@sbv-clients/ui-shared';

export const ImpersonatedLabel = () => {
  const { username, impersonatorUserName } = useAuth();

  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      right="0"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Chip
        label={
          <Box display="flex" columnGap={1}>
            <Typography fontWeight="bold">{impersonatorUserName}:</Typography>
            <Typography>{username}</Typography>
          </Box>
        }
        variant="filled"
        color="primary"
        sx={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
      />
    </Box>
  );
};

export const ImpersonatedLabelMobileView = () => {
  const { username, impersonatorUserName } = useAuth();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  return (
    <Tooltip
      open={open}
      onClose={handleClose}
      title={`${impersonatorUserName}: ${username}`}
      arrow
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
    >
      <IconButton color="primary" size="small" onClick={handleOpen}>
        <Icon name={'SupportAgent'} />
      </IconButton>
    </Tooltip>
  );
};
